import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { CircularProgress } from "@mui/material";

import { CommonDialog, CommonDialogContent, CommonDialogTitle } from "../../../common/dialogs";

import CreateRequestForm from "./create-request-form";

import "./styles.less";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import { createNewRequest } from "../../../../reducers/administration/requestSlice";
import { useSelector } from "react-redux";

interface CreateRequestDialogProps {
    open: boolean;
    onClose: () => void;
}

const CreateRequestDialog: React.FC<CreateRequestDialogProps> = ({ open, onClose }) => {
    const intl = useIntl();
    const dispatch = useDispatch<AppDispatch>();
    const validationErrors = useSelector((state: RootState) => state.administration.requests.validationErrors);
    const title = intl.formatMessage({ id: "create-request-dialog.title" });
    const [formErrors, setFormErrors] = useState({});
    const [form, setForm] = useState({
        requestUrl: "",
        // requestPriority: "",
        // requestSource: "",
        // requestId: "",
    });
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (!validationErrors) return;

        const formErrosTmp = validationErrors.reduce((accumulator, error) => {
            accumulator[error.field] = error;

            return accumulator;
        }, {});

        setFormErrors(formErrosTmp);
    }, [validationErrors, form]);

    const handleSubmitForm = async () => {
        setBusy(true);
        try {
            const resultAction = await dispatch(createNewRequest(form));

            if (!createNewRequest.rejected.match(resultAction)) {
                setForm({
                    requestUrl: "",
                    // requestPriority: "",
                    // requestSource: "",
                    // requestId: "",
                });
                onClose();
            }
        } catch (e) {
            console.error(e);
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <CommonDialog className="create-request-dialog" open={open}>
                <CommonDialogTitle title={title} onClose={onClose} withoutCloseIcon={false} />
                <CommonDialogContent>
                    {busy && <CircularProgress className="report-columns-dialog-circular-progress" size={32} />}

                    <CreateRequestForm
                        form={form}
                        disabled={false}
                        setForm={setForm}
                        onSubmit={handleSubmitForm}
                        validationErrors={formErrors}
                        onCancel={() => {
                            onClose();
                            setForm({
                                requestUrl: "",
                                // requestPriority: "",
                                // requestSource: "",
                                // requestId: "",
                            });
                        }}
                    />
                </CommonDialogContent>
            </CommonDialog>
        </>
    );
};

export default CreateRequestDialog;
